import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CustomerSharedService } from '../../customer-shared.service';
import { SmartSubTabBaseComponent } from '../../../../shared/components/smart-subtab-base.component';
import { ApplicationContextService } from '../../../../shared/services/application-context.service';
import { ApplicationConfigService } from '../../../../shared/services/application-config.service';

@Component({
  selector: 'app-master',
  templateUrl: './master.component.html',
  styleUrls: ['./master.component.css']
})
export class MasterComponent extends SmartSubTabBaseComponent implements OnInit {

  isConfirmLoading = false;

  constructor(
    public customerSharedService: CustomerSharedService,
    public route: ActivatedRoute,
    applicationContextService: ApplicationContextService,
    applicationConfigService: ApplicationConfigService
  ) {
    super(applicationContextService, applicationConfigService);
    this.parentTabName = 'Master';
    this.selectedTabIndex = 4;
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  onTabChange(index: number): string | undefined {
    return this.onSubTabChange(index);
  }
}
